import writeModelCatalog from "./writeModelCatalog.json";
import { resolveRetiredDirectWriteModel } from "./retiredDirectWriteModels";

export const DEFAULT_STYLE_GUIDE_GENERATE_SAMPLE_WRITE_MODEL = "gpt4omini";

// My Voice requires a trained voice; Muse 2 Alpha runs a comparison workflow.
// Neither is a single-model preview of the style instructions being edited.
const EXCLUDED_SAMPLE_MODELS = new Set(["myVoice", "muse-2-alpha"]);

export const STYLE_GUIDE_GENERATE_SAMPLE_MODEL_OPTIONS = writeModelCatalog.models
  .filter((model) => model.writeModelId && !EXCLUDED_SAMPLE_MODELS.has(model.writeModelId))
  .map((model) => ({ value: model.writeModelId, label: model.label }));

export const STYLE_GUIDE_GENERATE_SAMPLE_WRITE_MODELS = STYLE_GUIDE_GENERATE_SAMPLE_MODEL_OPTIONS.map((model) => model.value);

export function normalizeStyleGuideGenerateSampleWriteModel(writeModel) {
  const resolved = resolveRetiredDirectWriteModel(writeModel);
  const normalized = typeof resolved === "string" ? resolved.trim().toLowerCase() : "";
  if (!normalized) return "";
  return STYLE_GUIDE_GENERATE_SAMPLE_WRITE_MODELS.find((modelId) => modelId.toLowerCase() === normalized) ?? "";
}

export function isStyleGuideGenerateSampleWriteModel(writeModel) {
  return Boolean(normalizeStyleGuideGenerateSampleWriteModel(writeModel));
}
